import { render, staticRenderFns } from "./IncidentOverview.vue?vue&type=template&id=568fd52f&scoped=true"
import script from "./IncidentOverview.vue?vue&type=script&lang=js"
export * from "./IncidentOverview.vue?vue&type=script&lang=js"
import style0 from "./IncidentOverview.vue?vue&type=style&index=0&id=568fd52f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568fd52f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
